export default "__VITE_ASSET__7b3b8a17__"